/* ABR original blood animation, with viewport pause and user motion controls. */

(function () {
  'use strict';


  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  function rgba(c,a) { return 'rgba('+c.r+','+c.g+','+c.b+','+a.toFixed(3)+')'; }
  function rand(a,b) { return a + Math.random()*(b-a); }
  function easeOutExpo(t) { return t>=1?1:1-Math.pow(2,-10*t); }

  var C = {
    core:   {r:148,g:0,b:0}, mid:    {r:196,g:20,b:40},
    bright: {r:220,g:40,b:60}, edge:  {r:40,g:0,b:0},
    hl:     {r:255,g:130,b:120}, tail: {r:110,g:0,b:0},
    puddle: {r:70,g:0,b:0}, streak:   {r:90,g:0,b:0},
  };

  var COLS=15,MAX=30,RATE=240,WMN=5,WMX=22,ASP=1.7;
  var SMN=2.2,SMX=9,TMN=22,TMX=140,PMXN=120,PLIF=7500,SMXS=10;


  function init(hero) {
    if (hero.dataset.abrRainReady) return;
    hero.dataset.abrRainReady = 'true';
    var controller = new AbortController(), signal = controller.signal;
    var drops=[],puddles=[],splashes=[],streaks=[];
    var raf=null,ls=0,lss=0,used=new Array(COLS).fill(false);
    var rc = hero.querySelector('[data-abr-rain]');
    var sc = hero.querySelector('[data-abr-streaks]');
    var control = hero.querySelector('[data-abr-motion]');
    var media = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused=false, visible=true;
    if (!rc || !sc) return;
    var rctx=rc.getContext('2d'), sctx=sc.getContext('2d');
    var W=0,H=0;

    function resize() {
      W=hero.offsetWidth; H=hero.offsetHeight;
      [rc,sc].forEach(function(cv){
        cv.width=Math.round(W*DPR); cv.height=Math.round(H*DPR);
        cv.style.width=W+'px'; cv.style.height=H+'px';
      });
      rctx.scale(DPR,DPR); sctx.scale(DPR,DPR);
    }
    resize();
    window.addEventListener('resize',function(){
      rctx.setTransform(1,0,0,1,0,0); sctx.setTransform(1,0,0,1,0,0); resize();
    },{passive:true, signal:signal});

    function cx(ci){var m=W*0.025;return m+(ci/(COLS-1))*(W-m*2);}

    function spawn(now){
      if(drops.length>=MAX) return;
      var free=[];for(var i=0;i<COLS;i++){if(!used[i])free.push(i);}
      if(!free.length) return;
      var ci=free[Math.floor(Math.random()*free.length)]; used[ci]=true;
      var w=rand(WMN,WMX),j=(Math.random()-0.5)*(W/COLS)*0.45;
      drops.push({ci,x:cx(ci)+j,bx:cx(ci)+j,y:-(w*ASP)-rand(TMN,TMX),
        w,h:w*ASP,spd:rand(SMN,SMX),tail:rand(TMN,TMX),
        hlx:0.2+Math.random()*0.24,hly:0.14+Math.random()*0.18,
        a:0.72+Math.random()*0.28,ph:Math.random()*Math.PI*2,sw:rand(0.2,1.6),born:now});
    }

    function drawDrop(d){
      var x=d.x,y=d.y,w=d.w,h=d.h,a=d.a;
      rctx.save();
      var gr=w*2.2;
      var g=rctx.createRadialGradient(x,y+h*.5,0,x,y+h*.5,gr);
      g.addColorStop(0,rgba(C.core,a*.2)); g.addColorStop(.5,rgba(C.core,a*.06)); g.addColorStop(1,rgba(C.core,0));
      rctx.beginPath(); rctx.ellipse(x,y+h*.5,gr,gr*.75,0,0,Math.PI*2); rctx.fillStyle=g; rctx.fill();
      if(d.tail>0){
        var tg=rctx.createLinearGradient(x,y-d.tail,x,y);
        tg.addColorStop(0,rgba(C.tail,0)); tg.addColorStop(.25,rgba(C.tail,a*.1));
        tg.addColorStop(.7,rgba(C.tail,a*.44)); tg.addColorStop(1,rgba(C.core,a*.8));
        var tw=w*.15;
        rctx.beginPath(); rctx.moveTo(x-tw*.22,y-d.tail);
        rctx.quadraticCurveTo(x-tw,y-d.tail*.5,x-tw,y); rctx.lineTo(x+tw,y);
        rctx.quadraticCurveTo(x+tw,y-d.tail*.5,x+tw*.22,y-d.tail);
        rctx.closePath(); rctx.fillStyle=tg; rctx.fill();
      }
      var rx=w/2,ry=h/2,cy_=y+ry;
      rctx.beginPath(); rctx.moveTo(x,y);
      rctx.bezierCurveTo(x-rx*.07,y+h*.25,x-rx,y+h*.51,x-rx*.67,cy_+ry*.43);
      rctx.bezierCurveTo(x-rx*.67,cy_+ry*.93,x+rx*.67,cy_+ry*.93,x+rx*.67,cy_+ry*.43);
      rctx.bezierCurveTo(x+rx,y+h*.51,x+rx*.07,y+h*.25,x,y); rctx.closePath();
      var bg=rctx.createRadialGradient(x-rx*.22,cy_-ry*.58,0,x,cy_,h*.78);
      bg.addColorStop(0,rgba(C.bright,a*.92)); bg.addColorStop(.22,rgba(C.mid,a));
      bg.addColorStop(.58,rgba(C.core,a)); bg.addColorStop(1,rgba(C.edge,a*.96));
      rctx.fillStyle=bg; rctx.fill();
      rctx.save(); rctx.clip();
      var hlX=x-rx*d.hlx,hlY=y+h*d.hly;
      var hl=rctx.createRadialGradient(hlX,hlY,0,hlX,hlY,ry*.55);
      hl.addColorStop(0,rgba(C.hl,.34*a)); hl.addColorStop(.4,rgba(C.hl,.12*a)); hl.addColorStop(1,rgba(C.hl,0));
      rctx.beginPath(); rctx.ellipse(hlX,hlY,rx*.54,ry*.48,-.35,0,Math.PI*2); rctx.fillStyle=hl; rctx.fill();
      rctx.restore(); rctx.restore();
    }

    function drawPuddle(p,now){
      var age=now-p.born,life=age/PLIF; if(life>=1) return false;
      var gr=easeOutExpo(Math.min(age/300,1));
      var al=(1-Math.max(0,(life-.48)/.52))*.62*p.sc;
      var rx=p.mrx*gr,ry=p.mry*gr; if(rx<.5) return true;
      var g=rctx.createRadialGradient(p.x,H-2,0,p.x,H-2,rx);
      g.addColorStop(0,rgba(C.mid,al)); g.addColorStop(.38,rgba(C.core,al*.7)); g.addColorStop(1,rgba(C.puddle,0));
      rctx.beginPath(); rctx.ellipse(p.x,H-2,rx,ry,0,0,Math.PI*2); rctx.fillStyle=g; rctx.fill();
      return true;
    }

    function impact(d){
      var sc=d.w/WMX;
      if(puddles.length<PMXN) puddles.push({x:d.x,born:performance.now(),mrx:32+sc*55,mry:4.5+sc*7.5,sc:sc*.9+.1});
      var n=Math.floor(6+sc*10);
      for(var i=0;i<n;i++){
        var ang=(Math.random()-.5)*Math.PI*1.9-Math.PI*.5;
        splashes.push({x:d.x,y:H,vx:Math.cos(ang)*rand(1.2,5.5)*sc,vy:-Math.abs(Math.sin(ang))*rand(2,6.5)*sc,
          r:rand(.5,2.6)*sc,life:1,decay:rand(.048,.088),al:.5+sc*.38});
      }
    }

    function drawSplashes(){
      splashes=splashes.filter(function(s){
        s.x+=s.vx; s.y+=s.vy; s.vy+=.28; s.life-=s.decay;
        if(s.life<=0||s.y>H+8) return false;
        rctx.beginPath(); rctx.arc(s.x,s.y,s.r,0,Math.PI*2);
        rctx.fillStyle=rgba(C.mid,s.life*s.al); rctx.fill(); return true;
      });
    }

    function spawnStreak(){
      if(streaks.length>=SMXS) return;
      var xr=W*.22,side=Math.random()<.5?'l':'r';
      var x=side==='l'?rand(0,xr):rand(W-xr,W);
      streaks.push({x,y:rand(-120,0),len:rand(70,300),spd:rand(.3,1.1),w:rand(1,4),al:rand(.1,.38)});
    }

    function drawStreaks(){
      sctx.clearRect(0,0,W,H);
      streaks=streaks.filter(function(s){
        s.y+=s.spd; if(s.y-s.len>H) return false;
        var ty=Math.max(0,s.y-s.len),by=Math.min(H,s.y);
        var g=sctx.createLinearGradient(s.x,ty,s.x,by);
        g.addColorStop(0,rgba(C.streak,0)); g.addColorStop(.28,rgba(C.streak,s.al));
        g.addColorStop(.82,rgba(C.core,s.al*.85)); g.addColorStop(1,rgba(C.core,0));
        sctx.beginPath(); sctx.moveTo(s.x,ty); sctx.lineTo(s.x,by);
        sctx.strokeStyle=g; sctx.lineWidth=s.w; sctx.stroke();
        if(s.y<H){
          sctx.beginPath(); sctx.ellipse(s.x,s.y,s.w*2,s.w*3,0,0,Math.PI*2);
          sctx.fillStyle=rgba(C.core,s.al*.95); sctx.fill();
        }
        return true;
      });
    }

    function frame(now){
      raf=requestAnimationFrame(frame);
      rctx.clearRect(0,0,W,H);
      if(now-ls>RATE){spawn(now);ls=now;}
      if(now-lss>1500){spawnStreak();lss=now;}
      drawStreaks();
      puddles=puddles.filter(function(p){return drawPuddle(p,now);});
      drops=drops.filter(function(d){
        d.y+=d.spd; d.x=d.bx+Math.sin(d.ph+d.y*.011)*d.sw;
        if(d.y+d.h>=H){impact(d);used[d.ci]=false;return false;}
        drawDrop(d); return true;
      });
      drawSplashes();
    }
    function sync() {
      var run = visible && !document.hidden && !paused && !media.matches;
      if (run && !raf) raf=requestAnimationFrame(frame);
      if (!run && raf) { cancelAnimationFrame(raf); raf=null; }
      if (control) {
        control.hidden=media.matches;
        control.textContent=paused ? 'Resume animation' : 'Pause animation';
        control.setAttribute('aria-pressed', String(paused));
      }
    }
    if (control) control.addEventListener('click',function(){ paused=!paused;sync(); },{signal:signal});
    document.addEventListener('visibilitychange',sync,{signal:signal});
    media.addEventListener('change',sync,{signal:signal});
    var observer=new IntersectionObserver(function(entries){ visible=entries[0].isIntersecting;sync(); });
    observer.observe(hero);
    sync();
    document.addEventListener('shopify:section:unload',function(e){
      if(e.target.contains(hero)) { if(raf) cancelAnimationFrame(raf); observer.disconnect();controller.abort(); }
    },{signal:signal});
  }
  function boot(root) { root.querySelectorAll('.abr-hero').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
}());
